export const STORE_HOME_PAGE_PATHNAME = "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]";
export const STORE_BRAND_PAGE_PATHNAME =
  "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]/brand/[brandSlug]";
export const STORE_COLLECTION_PAGE_PATHNAME =
  "/[countryCode]/w/[workspaceSlug]/[storeIdentifier]/collection/[menuIdentifier]";
export const MENU_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/[category]`;
export const PRODUCT_VIEW_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/p/[productSlug]`;
export const HEADER_NAV_LINK_PATHNAME_PREFIX = "[countryCode]";
export const CATALOG_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/catalog`;
export const CATALOG_ENTRIES_PAGE_PATHNAME = `${STORE_HOME_PAGE_PATHNAME}/catalog/[categorySlug]`;

export const OLD_STORE_HOME_PAGE_PATHNAME = "/[countryCode]/[lang]/stores/[slug]/[storeNumber]";
export const OLD_STORE_BRAND_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/[slug]/[storeNumber]/brand/[brandSlug]";
export const OLD_STORE_COLLECTION_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/[slug]/[storeNumber]/collection/[menuIdentifier]";
export const OLD_MENU_PAGE_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/[category]`;
export const OLD_PRODUCT_VIEW_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/p/[productSlug]`;

export const DATA_PROVIDER_STORE_MENU = "store-menu";

export const CATEGORY_PRODUCT_LISTING_LINK_TYPE = "category-product-listing-link";
export const CATEGORY_HOME_LINK_TYPE = "category-home-link";
export const STORE_HOME_PAGE_LINK_TYPE = "store-home-page-link";
export const BRAND_LINK_TYPE = "brand-link";
export const PRODUCT_LINK_TYPE = "product-link";
export const HEADER_LOGO_LINK_TYPE = "header-logo-link";
export const CATALOG_HOME_LINK_TYPE = "catalog-home-link";
export const OTHER_LINK_TYPE = "other-link";
export const EXTERNAL_LINK_TYPE = "external-link";

export type LinkWithLangType =
  | typeof CATEGORY_PRODUCT_LISTING_LINK_TYPE
  | typeof CATEGORY_HOME_LINK_TYPE
  | typeof BRAND_LINK_TYPE
  | typeof OTHER_LINK_TYPE
  | typeof PRODUCT_LINK_TYPE
  | typeof HEADER_LOGO_LINK_TYPE
  | typeof CATALOG_HOME_LINK_TYPE
  | typeof EXTERNAL_LINK_TYPE
  | typeof STORE_HOME_PAGE_LINK_TYPE;

export const CATALOG_HOME = "Catalog Home";
export const CATEGORY_HOME = "Category Home";
export const CATEGORY_PRODUCT_LISTING = "Category Product Listing";
export const OTHER = "Other";
export const EXTERNAL_LINK = "External Link";

export const URL_TYPE_OPTIONS = [
  {
    label: CATALOG_HOME,
    value: CATALOG_HOME_LINK_TYPE,
  },
  {
    label: CATEGORY_HOME,
    value: CATEGORY_HOME_LINK_TYPE,
  },
  {
    label: CATEGORY_PRODUCT_LISTING,
    value: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  },
  {
    label: OTHER,
    value: OTHER_LINK_TYPE,
  },
  {
    label: EXTERNAL_LINK,
    value: EXTERNAL_LINK_TYPE,
  },
];

export const ITEM_FEATURES_FILTER_KEY = "itemFeatures";
export const ITEM_TYPE_FILTER_KEY = "item-type";
export const PRICE_FILTER_KEY = "price";

export enum SystemFilterKeys {
  SORT = "sort",
}

export const LOWEST_PRICE_RANGE_FILTER = "lowest-price-range";

export const FILTER_OPTION_VALUE = {
  NO_MINIMUM: "no-minimum",
  RECOMMENDED: "recommended",
  NEW_ARRIVALS: "new-arrivals",
  PREMIUM_COLLECTIONS: "premium-collections",
  SUSTAINABLE: "sustainable",
  ECO_FRIENDLY: "eco-friendly",
  LOWEST_PRICE_RANGE: LOWEST_PRICE_RANGE_FILTER,
} as const;

export type FilterOptionValue = typeof FILTER_OPTION_VALUE[keyof typeof FILTER_OPTION_VALUE];

export const RELEVANCE_SORT_ITEM = { label: "Relevant", name: "Relevant", id: "relevance" };
export const RECOMMENDED_SORT_ITEM = {
  label: "Recommended",
  name: "Recommended",
  id: "recommended",
};

export const NEWLY_ADDED_SORT_ITEM = {
  label: "Newly Added",
  name: "Newly Added",
  id: "created_at:desc",
};

export const SUSTAINABLE_FILTER = {
  id: "sustainable",
};
export const ECO_FRIENDLY_FILTER = {
  id: "eco-friendly",
};
export const PREMIUM_COLLECTIONS_FILTER = {
  id: "price:desc",
};
export const ON_DEMAND_FILTER_TYPE = {
  id: "on-demand",
};
export const CORE_ON_DEMAND_FILTER_TYPE = {
  id: "core-demand",
};
export const ADDITIONAL_ON_DEMAND_FILTER_TYPE = {
  id: "additional-on-demand",
};

const ITEM_FEATURES_QUERY_KEY = `${ITEM_FEATURES_FILTER_KEY}[]` as const;
const ITEM_TYPE_QUERY_KEY = `${ITEM_TYPE_FILTER_KEY}[]` as const;
export const FILTER_SYNC_QUERY = { syncFilter: "true" };

const FILTER_OPTION_SPECS: readonly {
  value: FilterOptionValue;
  label: string;
  query: Record<string, string>;
}[] = [
  {
    value: FILTER_OPTION_VALUE.NO_MINIMUM,
    label: "No Minimum",
    query: {
      [ITEM_TYPE_QUERY_KEY]: [
        ON_DEMAND_FILTER_TYPE.id,
        CORE_ON_DEMAND_FILTER_TYPE.id,
        ADDITIONAL_ON_DEMAND_FILTER_TYPE.id,
      ].join(","),
      ...FILTER_SYNC_QUERY,
    },
  },
  {
    value: FILTER_OPTION_VALUE.RECOMMENDED,
    label: "Recommended",
    query: { [SystemFilterKeys.SORT]: RECOMMENDED_SORT_ITEM.id, ...FILTER_SYNC_QUERY },
  },
  {
    value: FILTER_OPTION_VALUE.NEW_ARRIVALS,
    label: "New Arrivals",
    query: { [SystemFilterKeys.SORT]: NEWLY_ADDED_SORT_ITEM.id, ...FILTER_SYNC_QUERY },
  },
  {
    value: FILTER_OPTION_VALUE.PREMIUM_COLLECTIONS,
    label: "Premium Collections",
    query: { [SystemFilterKeys.SORT]: PREMIUM_COLLECTIONS_FILTER.id, ...FILTER_SYNC_QUERY },
  },
  {
    value: FILTER_OPTION_VALUE.SUSTAINABLE,
    label: "Sustainable",
    query: { [ITEM_FEATURES_QUERY_KEY]: SUSTAINABLE_FILTER.id, ...FILTER_SYNC_QUERY },
  },
  {
    value: FILTER_OPTION_VALUE.ECO_FRIENDLY,
    label: "Eco-friendly",
    query: { [ITEM_FEATURES_QUERY_KEY]: ECO_FRIENDLY_FILTER.id, ...FILTER_SYNC_QUERY },
  },
  {
    value: FILTER_OPTION_VALUE.LOWEST_PRICE_RANGE,
    label: "Lowest Price Range",
    query: { [PRICE_FILTER_KEY]: LOWEST_PRICE_RANGE_FILTER, ...FILTER_SYNC_QUERY },
  },
];

export const FILTER_OPTIONS_VALUES = FILTER_OPTION_SPECS.reduce((acc, spec) => {
  acc[spec.value] = { ...spec.query };
  return acc;
}, {} as Record<FilterOptionValue, Record<string, string>>);

export const FILTER_OPTIONS: { label?: string; value?: keyof typeof FILTER_OPTIONS_VALUES }[] =
  FILTER_OPTION_SPECS.map(({ label, value }) => ({ label, value }));

export const CATALOG_REQUEST_ITEM_TYPE_FORM_LINK = "https://by-stadium.typeform.com/to/XSWKnSOq";
